<template>
  <div class="legend-mesh">
    <div v-for="cell in cells" v-bind:key="cell.index" class="cell-row">
      <div
        class="color-block"
        v-bind:style="{
          'background-color': cell.rgbColor,
        }"
      />
      <span class="legend-text">
        {{ cell.value }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAnalyzeLegendMesh',
  inheritAttrs: false,
  props: {
    /**
     * カラーレンジ
     */
    colorRange: {
      type: Array,
      default: () => [],
    },
    /**
     * 値のレンジ
     */
    valueRange: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    /**
     * 各セルの値
     * @type {Array.<Number>}
     */
    values: function () {
      if (!this.valueRange) return []

      let { min, max } = this.valueRange
      min = min || 0
      max = max || 0
      const valueRange = max - min
      const step = valueRange / this.colorRange.length
      let values = [{ index: 0, value: min }]
      if (min !== max) {
        for (let i = 1; i < this.colorRange.length; ++i) {
          const value = Math.ceil(min + i * step)
          if (values[values.length - 1].value === value) {
            values.pop()
          }
          values.push({ index: i, value })
        }
      }
      return [...values].reverse()
    },
    /**
     * セル表示用情報
     * @type {Array.<Object>}
     */
    cells: function () {
      let cells = []
      for (let i = 0; i < this.colorRange.length; ++i) {
        const valueItem = this.values.find((v) => v.index === i)
        if (valueItem) {
          cells.push({
            index: i,
            color: this.colorRange[i],
            rgbColor: `rgb(${this.colorRange[i].slice(0, 3).join(',')})`,
            value: valueItem.value,
          })
        }
      }
      return [...cells].reverse()
    },
  },
}
</script>

<style lang="scss" scoped>
$-cell-size: 24px;

.legend-mesh {
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
}

.cell-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  column-gap: 16px;

  .color-block {
    width: $-cell-size;
    height: $-cell-size;
  }

  .legend-text {
    line-height: 1;
  }
}
</style>
